import React from 'react';
import './PromotionalBanner.css';

const PromotionalBanner = () => {
  return (
    <div className="promotional-banner">
      <p>
        10% OFF ALL Sessions in June!{' '}
      </p>
    </div>
  );
};

export default PromotionalBanner; 